import { c as _c } from "react/compiler-runtime";
import { OutcomeIdentityImage } from '@/components/market/identity/outcome-identity-image';
import { SettledSeal } from '@/components/market/settled-seal';
import { Badge } from '@/components/ui/app-badge';
import { useMarketOutcomeColor } from '@/hooks/chart/use-outcome-color';
import { cn } from '@/lib/ui/utils';

// Leaf module for the shared outcome row/card sub-components. Lives apart from
// `other-outcomes-table` so `other-outcome-card` can use these without the
// table↔card import cycle (table → card → these parts).

interface OutcomeThumbProps {
  marketPubkey: string;
  index: number;
  imageUrl: string | null;
  imageNsfw: boolean;
  /** Tailwind size class, e.g. `size-8`. */
  size: string;
  showSettledBadge?: boolean;
  rankLabel?: string | undefined;
}

/** Outcome thumbnail (NSFW-aware, hue-tinted) shared by the desktop row + mobile card. */
export function OutcomeThumb(t0) {
  const $ = _c(19);
  const {
    marketPubkey,
    index,
    imageUrl,
    imageNsfw,
    size,
    showSettledBadge: t1,
    rankLabel
  } = t0;
  const showSettledBadge = t1 === undefined ? false : t1;
  const colors = useMarketOutcomeColor(marketPubkey, index);
  let t2;
  if ($[0] !== colors.cta || $[1] !== size) {
    t2 = cn("relative flex shrink-0 items-center justify-center rounded-panel-inset", size, colors.cta);
    $[0] = colors.cta;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = imageUrl ?? null;
  let t4;
  if ($[3] !== colors.hue || $[4] !== imageNsfw || $[5] !== index || $[6] !== marketPubkey || $[7] !== t3) {
    t4 = {
      kind: "outcome",
      marketPubkey,
      outcomeIndex: index,
      hue: colors.hue,
      imageUrl: t3,
      nsfw: imageNsfw
    };
    $[3] = colors.hue;
    $[4] = imageNsfw;
    $[5] = index;
    $[6] = marketPubkey;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== size || $[10] !== t4) {
    t5 = <OutcomeIdentityImage variant="thumbnail" entity={t4} alt="" size={size} rounded="rounded-panel-inset" preview={false} loadReveal="none" className="size-full object-cover" />;
    $[9] = size;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== rankLabel || $[13] !== showSettledBadge) {
    t6 = showSettledBadge ? <SettledSeal className="pointer-events-none absolute -bottom-1.5 -right-1.5 z-10 size-5" /> : rankLabel === undefined ? null : <Badge variant="secondary" className="absolute -bottom-1.5 -right-1.5 z-10">{rankLabel}</Badge>;
    $[12] = rankLabel;
    $[13] = showSettledBadge;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t6) {
    t7 = <span className={t2}>{t5}{t6}</span>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}